module.exports = __webpack_public_path__ + "static/img/area02.19690d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/area02.png
// module id = sQ3H
// module chunks = 3